import React from "react";
import { connect } from "react-redux";

import { Typography } from "@material-ui/core";
import { setState } from "../store/actions";
import { post } from "../lib/api";
import Sponsors from "./Sponsors";

class Info extends React.Component {


    render() {
        const { attendeeInfo } = this.props;
        return (
            <div style={{
                lineHeight: "160%",
                fontSize: "16px",
                maxWidth: "1100px",
                margin: "auto",
            }}>
                <p style={{ textAlign: "right", fontSize: "0.8em" }}>
                    <span style={{ display: "inline-block", textAlign: "left", lineHeight: "1.5em" }}>
                        {
                            attendeeInfo.name && <>
                                Συνδεθήκατε ως: <br /><b>{attendeeInfo.name} {attendeeInfo.surname}</b>
                            </>
                        }
                    </span>
                </p>
                <img src="/files/img/banner.png" style={{ width: "100%", marginBottom: "20px" }} />
                <p><b>Καλώς ορίσατε στην ΙΘ΄/ 19η Γενική Συνέλευση του Σωματείου «ΔΙΑΖΩΜΑ», η οποία θα πραγματοποιηθεί την Κυριακή 11 Οκτωβρίου 2026 στο Πολιτιστικό Συνεδριακό Κέντρο Ηρακλείου και στο χρονικό διάστημα: 10:00 π.μ. – 15:30 μ.μ., με την παρακάτω θεματολογία:</b></p>
                <p>1. Έγκριση του απολογισμού δράσης του Διοικητικού Συμβουλίου για το έτος 2026.</p>
                <p>2. Έγκριση του οικονομικού και διαχειριστικού απολογισμού από 1η Ιανουαρίου έως την 31η Αυγούστου του 2026.</p>
                <p>3. Έγκριση του οικονομικού και διαχειριστικού απολογισμού από 1η Ιανουαρίου έως την 31η Δεκεμβρίου του 2025.</p>
                <p>4. Έγκριση του προγραμματισμού δράσεων για το έτος 2027.</p>
                <p>5. Έγκριση του προϋπολογισμού για το έτος 2027.</p>
                <p>6. Έγκριση της Έκθεσης της Ελεγκτικής Επιτροπής για το έτος 2025.</p>
                <p>Η φετινή μας Γενική Συνέλευση αποτελεί, όπως κάθε χρόνο, μια ξεχωριστή ευκαιρία να συναντηθούμε με τα μέλη, τους φίλους και τους πολύτιμους συνοδοιπόρους του Σωματείου, να μοιραστούμε όσα πετύχαμε τη χρονιά που πέρασε και να παρουσιάσουμε τα επόμενα βήματα και τους νέους στόχους του «ΔΙΑΖΩΜΑΤΟΣ».</p>
                <p><b>Σας παρακαλούμε θερμά την ημέρα της Γενικής μας Συνέλευσης να συνδεθείτε στην παρούσα σελίδα (με τον ίδιο σύνδεσμο) μισή ώρα πριν την έναρξη των εργασιών, δηλαδή στις 9:30 π.μ.</b></p>
                <p style={{ textAlign: "center" }}>Σας ευχαριστούμε για τη συμμετοχή σας και τη διαρκή σας στήριξη στο Σωματείο μας.</p> 
                <p style={{ textAlign: "center" }}>
                <br />
                <b>ΣΥΝΔΙΟΡΓΑΝΩΣΗ ΣΥΝΕΛΕΥΣΗΣ:</b><br />
                ΣΩΜΑΤΕΙΟ «ΔΙΑΖΩΜΑ» ΚΑΙ «ΔΙΚΤΑΙΟΝ ΠΑΡΑΧΩΡΗΣΕΙΣ Α.Ε.»<br />
                <br />
                <b>ΕΠΙΣΗΜΟΣ ΧΟΡΗΓΟΣ ΑΕΡΟΜΕΤΑΦΟΡΩΝ</b><br />
                Aegean Airlines<br />
                <br />
                <b>ΧΟΡΗΓΟΣ ΝΕΡΟΥ & ΑΝΑΨΥΚΤΙΚΩΝ</b><br />
                Εταιρεία «ΒΙΚΟΣ Α.Ε.»<br />
                <br />
                Η Γενική Συνέλευση υποστηρίζεται από το Bodossaki Lectures on Demand-BLOD, την ηλεκτρονική βιβλιοθήκη διαλέξεων (<a href="https://blod.gr" target="_blank" rel="noopener noreferrer">blod.gr</a>) του Ιδρύματος Μποδοσάκη
                <br />
                </p>
                <Sponsors style={{ marginTop: "50px" }} />
            </div>
        );
    }
}

Info.defaultProps = {
    sponsorImg: [],
    sponsorImgStart: 0,
    attendeeInfo: {}
};

const mapStateToProps = state => {
    return Object.keys(Info.defaultProps).reduce(
        (obj, key) => ({ ...obj, [key]: state[key] }),
        {}
    );
};

function mapDispatchToProps(dispatch) {
    return {
        setState: state => dispatch(setState(state))
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(Info);
